import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const ArrivalIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "ArrivalGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M21.5773 20.1125H3.49546C3.21543 20.1125 2.98883 19.8859 2.98883 19.6058C2.98883 19.3258 3.21543 19.0992 3.49546 19.0992H21.5773C21.8573 19.0992 22.0839 19.3258 22.0839 19.6058C22.0839 19.8859 21.8573 20.1125 21.5773 20.1125Z"
        fill="#696969"
      />
      <path
        d="M20.352 17.5056C20.0216 17.5696 19.6566 17.5667 19.2627 17.4792L6.76423 14.3535C5.8026 14.1134 5.01515 13.4578 4.60407 12.5551L2.77951 8.54478L2.77832 8.54134C2.55763 8.04696 2.5429 7.49642 2.73644 6.99113C2.9305 6.48574 3.30941 6.08632 3.80338 5.86623C4.69724 5.46894 5.74499 5.76327 6.29779 6.56821L8.44181 9.68498L20.4475 12.6872C21.9995 13.1154 22.5118 14.5136 22.2217 15.6755C22.0058 16.5427 21.3308 17.3161 20.352 17.5056ZM3.74174 8.11011L5.56529 12.118C5.84211 12.7259 6.37236 13.1677 7.02009 13.3295L19.5058 16.4519C20.4387 16.6598 21.0318 16.0839 21.1977 15.4196C21.3638 14.7538 21.1131 13.9659 20.1789 13.7079L7.99175 10.6605C7.86709 10.6295 7.75787 10.5535 7.68482 10.4474L5.42758 7.16619C5.16244 6.78123 4.66168 6.64089 4.23361 6.82983C3.99681 6.93554 3.81499 7.12721 3.72213 7.36886C3.62977 7.61042 3.63663 7.87372 3.74174 8.11011Z"
        fill="#696969"
      />
      <path
        d="M16.5902 12.7721C16.5158 12.7865 16.4378 12.7848 16.3617 12.7659L11.9321 11.6579C11.7268 11.6063 11.5717 11.4374 11.539 11.2279L10.3182 3.49421C10.2906 3.31946 10.3523 3.14212 10.4831 3.02282C10.6128 2.90372 10.795 2.85742 10.9676 2.90012L12.9595 3.39857C13.738 3.59328 14.3541 4.16388 14.607 4.92453L16.9905 12.0871C17.0516 12.27 17.0081 12.4711 16.877 12.6126C16.7992 12.6964 16.6985 12.7511 16.5902 12.7721ZM12.5272 10.7184L15.6856 11.5086L13.6057 5.25807C13.4667 4.84132 13.1296 4.52911 12.7036 4.42258L11.4853 4.11772L12.5272 10.7184Z"
        fill="#696969"
      />
    </svg>
  );
};

export default ArrivalIcon;
